import TimelineItem from "@/pages/articles-pages/programmes/MultiStepForm/MicroSite/Templates/SitecraftTemplate/Mission/TimelineItem"
import TimelineItemForm from "@/pages/articles-pages/programmes/MultiStepForm/MicroSite/Templates/Shared/TimelineItemForm";
import { Button } from "@/components/ui"
import { useMicroSiteContext } from "@/contexts/MicroSiteContext";
import { useState } from "react"

const MissionTimeline = () => {
    const { templatePayload:data } = useMicroSiteContext();
      const isEdit = new URLSearchParams(window.location.search).get('action') === 'edit';

  const [showForm, setShowForm] = useState(false);
  return (
    <div className="flex relative flex-col w-full p-4 lg:p-8 gap-6  justify-center" >
      <div className="grid gap-4 lg:gap-12 w-full px-4 lg:px-4">
      {data.missionTimeLineSection.missionTimeLineSectionDetails.map((item, index) => (
        // Item index is passed to help identify which item is being deleted because multiple items can have the same content and there is no unique id
        <TimelineItem key={index} data={item} itemIndex={index} />
      ))}
    </div>

    {showForm && (
       <TimelineItemForm setShowForm={setShowForm} />
    )}

  {isEdit &&  <div className="mt-12">
      <Button className="w-full lg:w-1/3 bg-forestGreen-200 border border-dashed !border-forestGreen-100 !text-forestGreen-100 hover:!text-white" onClick={()=>{
        setShowForm(true)
      }} >Add New Mission Section</Button>
    </div>}
    </div>
    
  )
}

export default MissionTimeline